import React from 'react';
import {Player} from '@lottiefiles/react-lottie-player';

export const Success = () => {

    return (
        <div
            style={{
                display: 'block',
                textAlign: 'center',
                fontFamily: 'IRANSans'
            }}>
            <Player
                style={{
                    width: '250px',
                    height: '250px',
                    marginTop: '40px',
                    display: 'block',
                    margin: 'auto'
                }}
                src='/success.json'
                className="player"
                loop={false}
                autoplay={true}
                speed='0.7'
                keepLastFrame={true}
            />
            <div>
                درخواست شما با موفقیت ثبت شد.
            </div>
            <div>
                کارشناسان ما در اسرع وقت با شما تماس میگیرند.
            </div>
        </div>
    )
}